import { configureStore } from '@reduxjs/toolkit'
import userReducer from './user/userSlice'
import multiMemberLLCReducer from './legalTools/multiMemberLLCSlice'

export default configureStore({
  reducer: {
    user:userReducer,
    multiMemberLLC:multiMemberLLCReducer
  },
})